import { noOp } from 'common/Constants';
import React, { useState } from 'react';
import { CategoryPageRecentReviewsDocument, CategoryPageRecentReviewsQuery } from 'src/gqlReactTypings.generated.d';
import { Carousel } from 'src/shared/design-system/DishFirst/Carousel';
import { useOnMount } from 'src/shared/hooks/useOnMount';
import { useGqlClient } from 'src/shared/useGqlClient';
import { useGlobalReducer } from 'src/shef-global-state/shefGlobalState';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { SegmentHeaderTitle } from '../../../styles';
import { MaxWidthContainer } from '../styles';
import background from './assets/background.png';
import { ReviewCard } from './ReviewCard';
import { ReviewCardProps } from './types';

const Wrapper = styled.div`
  background-image: url(${background});
  background-size: cover;
  background-repeat: no-repeat;
  padding: ${Spacing.QUADRUPLE} 0;
  margin-bottom: ${Spacing.QUADRUPLE};
`;

export const CategoryPageRecentReviews: React.FC = () => {
  const [reviews, setReviews] = useState<ReviewCardProps[] | undefined>();
  const { state } = useGlobalReducer();
  const { userRegionId } = state;
  const GqlClient = useGqlClient();

  useOnMount(() => {
    const loadReviews = async () => {
      const { data } = await GqlClient.query<CategoryPageRecentReviewsQuery>({
        variables: { regionId: userRegionId ?? -1 },
        query: CategoryPageRecentReviewsDocument,
      });
      const { recentReviews } = data?.categoryPageRecentReviews ?? {};
      setReviews(recentReviews);
    };
    loadReviews().catch(noOp);
  });

  if (!reviews) return null;

  return (
    <Wrapper>
      <MaxWidthContainer className='md:px-4'>
        <div className='px-4 pb-4 md:px-0'>
          <SegmentHeaderTitle>Recently reviewed</SegmentHeaderTitle>
        </div>
        <div className='relative'>
          <Carousel content={reviews} showScrollButtons={true}>
            {reviews.map((review) => (
              <ReviewCard key={review.review.comment} {...review} />
            ))}
          </Carousel>
        </div>
      </MaxWidthContainer>
    </Wrapper>
  );
};
